//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "../../constants/actionType";
import { broadCastService } from "services/notifications/BroadCastService";


let initialState = {
    isApplicant: false,
    IsCoApp: false,
    applicant: {
        score_value: "", score_date: "", collection: []
    },
    coapp: {
        score_value: "", score_date: "", collection: []
    }
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.CLIENT_SCORE_SUMMARY:
            if (action.payload.showNotification){
                broadCastService.broadCast("creditSummaryBroadCastShow");
            }
            return _.assign({}, state, {
                isApplicant: action.payload.isApplicant,
                IsCoApp: action.payload.IsCoApp,
                applicant: action.payload.applicant,
                coapp: action.payload.coapp,
            });
        case actionType.CLIENT_SCORE_SUMMARY_RESET:
            return initialState;
        default:
            return state;
    }
}